module.exports = __webpack_public_path__ + "static/media/promo_band_2.cbbe030c.jpg";